import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "components/profiles/ProfileStyles";
import Actions from "./AdmissionTableAction";
import Grid from "@material-ui/core/Grid";
import MessagePaper from "components/messagePaper/MessagePaper";
import { dateToBR } from "utils/dates/DateToBRr";
import { getSorting, stableSort } from "utils/tables/createContent";
import { compareStrings } from "utils/sort/strings";

const AdmissionTable = props => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState({});
  const [rowsLength, setRowsLength] = useState(0);
  const [headers, setHeaders] = useState([]);
  const [mainField, setMainField] = useState("isActiveInHR");
  const [visibleHeaders, setVisibleHeaders] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("isActiveInHR");
  const [t] = useTranslation();

  function desc(a, b, orderBy) {
    if (a[orderBy] === null || a[orderBy] === undefined) {
      a[orderBy] = "";
    }
    if (b[orderBy] === null || b[orderBy] === undefined) {
      b[orderBy] = "";
    }

    if (orderBy === "type") {
      return compareStrings(
        getOperation(a[orderBy]).toString(),
        getOperation(b[orderBy]).toString()
      );
    }

    return compareStrings(a[orderBy].toString(), b[orderBy].toString());
  }

  function createContent(rows, headers, order, orderBy) {
    const rowsCopy = [];
    var obj = {};
    for (var i = 0; i < rows.length; i++) {
      for (var j = 0; j < headers.length; j++) {
        if (headers[j] === "isActiveInHR") {
          obj[headers[j]] = rows[i][headers[j]] ? "Ativo" : "Inativo";
        } else {
          obj[headers[j]] = rows[i][headers[j]];
        }
      }
      rowsCopy.push(obj);
      obj = {};
    }
    return stableSort(rowsCopy, getSorting(order, orderBy, desc));
  }

  function getOperation(value) {
    switch (value) {
      case "ADMISSION":
        return t("HR.admission");
      case "SALARY":
        return t("HR.changeOfSalary");
      case "DEMISSION":
        return t("HR.demission");
      case "JOB":
        return t("HR.changeOfPosition");
      case "HOLIDAY_DATE":
        return t("HR.changeOfDateVacation");
      case "DEMISSION_DATE":
        return t("HR.changeOfDemissionDate");
      case "ADMISSION_DATE":
        return t("HR.changeOfAdmissionDate");
      case "CONTRACT_END_DATE":
        return t("HR.changeOfContractEndDate");
      case "CONTRACT_FILE":
        return t("HR.changeOfContract");
      case "ADMISSION_EXAM_FILE":
        return t("HR.changeOfAdmissionExam");
      case "DEMISSION_EXAM_FILE":
        return t("HR.changeOfDemissionExam");
      case "DEMISSION_CRAFT_FILE":
        return t("HR.changeOfCraft");
      default:
        break;
    }
  }

  React.useEffect(() => {
    setHeaders(props.headers);
    setRows(props.rows);
    setRowsLength(props.rows.length);
    setMainField(props.mainField);
    setVisibleHeaders(props.visibleHeaders);
    setSortedFields(props.sortedFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.headers, props.mainField, props.rows, props.visibleHeaders]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }
  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === sortedFields[property] && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(sortedFields[property]);
  };

  const UsersTableHead = props => {
    const { order, orderBy, onRequestSort } = props;
    const [t] = useTranslation();
    const paginationTop = action => e => {
      var selector = "[aria-label^='" + action + "']";
      document.querySelector(selector).click();
      e.preventDefault();
    };
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {visibleHeaders.map((header, index) => (
            <StyledTableCell
              key={index}
              size="small"
              align="left"
              sortDirection={orderBy === sortedFields[index] ? order : false}
            >
              <TableSortLabel
                active={orderBy === sortedFields[index]}
                direction={order}
                onClick={createSortHandler(index)}
                // disabled={index === 0 || index === 5 || index === 7}
              >
                {header.toUpperCase()}
                {orderBy === sortedFields[index] ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  UsersTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  React.useEffect(() => {
    if (props.toFirstPage) {
      document.getElementById("toFirstPage").click();
    }
  }, [props.rows, props.toFirstPage]);

  const toFirstPage = () => {
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          {rows.length > 0 && (
            <UsersTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          )}
          <TableBody>
            {props.noHistoric ? (
              <React.Fragment>
                <Grid container item spacing={2} md={12} lg={12}>
                  <MessagePaper headerText={t("HR.noHistoric")} />
                </Grid>
              </React.Fragment>
            ) : (
              createContent(rows, headers, order, orderBy)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(row => (
                  <StyledTableRow key={row.id}>
                    <TableCell size="small">
                      {dateToBR(new Date(row["date"]))}
                    </TableCell>
                    <TableCell size="small">
                      {getOperation(row["type"])}
                    </TableCell>
                    <TableCell size="small">{row["user"]}</TableCell>
                    <TableCell size="small" align="right">
                      <div
                        style={{
                          marginTop: "auto",
                          marginBottom: "auto",
                          display: "flex",
                          flexWrap: "nowrap ",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Actions
                          item={row}
                          name={row.name}
                          permission={props.permission}
                        />
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))
            )}
          </TableBody>
        </Table>
        <button hidden id="toFirstPage" onClick={toFirstPage}></button>
        {rows.length > 0 && (
          <TableFooter style={{ float: "right" }}>
            <TablePagination
              labelRowsPerPage={"Resultados por página"}
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              component="div"
              onPageChPage={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </TableFooter>
        )}
      </div>
    </Paper>
  );
};

AdmissionTable.propTypes = {
  rows: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  visibleHeaders: PropTypes.array.isRequired,
  mainField: PropTypes.string.isRequired,
};

export default AdmissionTable;
